exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-title[data-v-1f20cfd6]{margin-bottom:30px}.custom-title[data-v-1f20cfd6],.page-template-perm_page_new .main h1.cat_title[data-v-1f20cfd6]{text-align:right}.not-width-100[data-v-1f20cfd6]{width:auto;display:inline-block;margin:0 auto}@media screen and (max-width:800px){.custom-title[data-v-1f20cfd6],.page-template-perm_page_new .main h1.cat_title[data-v-1f20cfd6],.perma-botn[data-v-1f20cfd6]{text-align:center}.not-width-100[data-v-1f20cfd6]{padding:0 1.25rem}}", ""]);

// exports
